import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    title: {
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800,
        marginBottom: theme.spacing[12]
    },
    subTitle: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700,
        marginBottom: theme.spacing[12]
    }
}));

const ContentTitleText = ({ title, subTitle, textAlignVariant }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <>
            <Typography className={classNames(classes.title)}>
                {title}
            </Typography>
            {
                subTitle && (
                    <Typography className={classNames(classes.subTitle)} style={{ textAlign: textAlignVariant }}>
                        {subTitle}
                    </Typography>
                )
            }
        </>
    );
};

ContentTitleText.defaultProps = {
    textAlignVariant: 'left'
};

ContentTitleText.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    textAlignVariant: PropTypes.string
};

export { ContentTitleText };
